import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarBlank } from "@phosphor-icons/react";
import { api } from "../../lib/api";
import { fr as frLocale } from "date-fns/locale";
import { Calendar } from "../ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import PerformanceDashboard from "../telepro/PerformanceDashboard";

// VAGUE 43 — performance équipe / télépro + date de départ de la nouvelle stratégie.
export default function AdminPerformancePanel({ telepros }) {
  const [code, setCode] = useState("");
  const [data, setData] = useState(null);
  const [start, setStart] = useState("");

  const load = () => {
    setData(null);
    api.get(`/admin/telepro/performance${code ? `?telepro_code=${encodeURIComponent(code)}` : ""}`)
      .then((r) => { setData(r.data); setStart((r.data.strategy_start || "").slice(0, 10)); })
      .catch(() => setData({ error: true }));
  };
  useEffect(load, [code]); // eslint-disable-line react-hooks/exhaustive-deps

  const saveStart = async () => {
    try {
      await api.put("/admin/telepro/strategy-start", { date: start });
      toast.success("Date de départ enregistrée");
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Date invalide");
    }
  };
  const resetStart = async () => {
    try {
      await api.delete("/admin/telepro/strategy-start");
      toast.success("Date automatique rétablie");
      load();
    } catch {
      toast.error("Impossible de rétablir la date");
    }
  };

  return (
    <div className="space-y-4" data-testid="admin-performance-panel">
      <div className="bg-card border border-border rounded-sm p-4 flex flex-wrap items-end gap-3">
        <label className="text-xs">
          <span className="block text-[10px] uppercase tracking-widest font-bold text-muted-foreground mb-1">Télépro</span>
          <select value={code} onChange={(e) => setCode(e.target.value)} className="border border-border rounded-sm px-2 py-1.5 bg-background text-sm" data-testid="admin-perf-telepro-select">
            <option value="">Toute l&apos;équipe</option>
            {telepros.map((t) => <option key={t.id} value={t.code}>{t.first_name} {t.last_name} ({t.code})</option>)}
          </select>
        </label>
        <div className="text-xs">
          <span className="block text-[10px] uppercase tracking-widest font-bold text-muted-foreground mb-1">Départ nouvelle stratégie</span>
          <Popover>
            <PopoverTrigger asChild>
              <button type="button" className="inline-flex items-center gap-1.5 border border-border rounded-sm px-2.5 py-1.5 bg-background text-sm min-w-[150px]" data-testid="admin-perf-start-input">
                <CalendarBlank size={14}/> {start ? new Date(`${start}T12:00:00`).toLocaleDateString("fr-FR") : "Choisir une date"}
              </button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
              <Calendar
                mode="single"
                locale={frLocale}
                selected={start ? new Date(`${start}T12:00:00`) : undefined}
                onSelect={(d) => d && setStart(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`)}
                disabled={(d) => d > new Date()}
                data-testid="admin-perf-start-calendar"
              />
            </PopoverContent>
          </Popover>
        </div>
        <button type="button" onClick={saveStart} disabled={!start} className="text-xs font-bold bg-primary text-primary-foreground rounded-sm px-3 py-2 disabled:opacity-50" data-testid="admin-perf-start-save">
          Enregistrer la date
        </button>
        <button type="button" onClick={resetStart} className="text-xs font-semibold border border-border rounded-sm px-3 py-2" data-testid="admin-perf-start-reset">
          Revenir à la date automatique
        </button>
      </div>
      <div className="bg-card border border-border rounded-sm p-4">
        {!data ? <div className="text-sm text-muted-foreground">Chargement…</div>
          : data.error ? <div className="text-sm text-secondary">Statistiques indisponibles.</div>
          : <PerformanceDashboard data={data}/>}
      </div>
    </div>
  );
}
